import {
  AccountHierarchyListItem,
  AccountHierarchyNested,
} from '@monetize/types/app';

type AccountHierarchyNodeWithoutResponseType = Omit<
  AccountHierarchyNested,
  'responseType'
>;

export const convertNestedAccountHierarchyToList = (
  accountHierarchy: AccountHierarchyNested,
): AccountHierarchyListItem[] => {
  const result: AccountHierarchyListItem[] = [];

  const processNode = (
    node: AccountHierarchyNodeWithoutResponseType,
    parentId: string | null | undefined,
    level: number,
  ): void => {
    result.push({
      id: node.id,
      name: node.name,
      parentId,
      level,
    });

    if (node.children && node.children.length > 0) {
      for (const child of node.children) {
        processNode(child, node.id, level + 1);
      }
    }
  };

  // Extract the root node without responseType for processing
  const { responseType, ...rootNode } = accountHierarchy;
  processNode(rootNode, null, 0);
  return result;
};
